import { createAction } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const setBalancesLoading = createAction<boolean>(
  'user/setBalancesLoading',
)

export const setBalancesLoadingReducer = (
  state: AppState['balances'],
  action: ReturnType<typeof setBalancesLoading>,
): void => {
  state.isLoading = action.payload
}
